import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { PartnerListFacade } from './partner-list.facade';

@Injectable({
  providedIn: 'root',
})
export class PartnerListGuard {
  constructor(private partnerListFacade: PartnerListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.partnerListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.partnerListFacade);
  }
}
